import { createFileRoute } from '@tanstack/react-router';

import { SettingLayout } from '@/features/setting/ui/setting.layout';

export const Route = createFileRoute('/workspace/$workspaceId/settings')({
  component: RouteComponent,
});

function RouteComponent() {
  return <SettingLayout />;
}
